import { useQuery } from "react-query";
import { searchAttributes } from "components/attributes/lib/attribute-data";

export const useAttributes = (searchValue, sourcePage) => {
    return useQuery({
        queryKey: ["attributes", searchValue],
        queryFn: () => searchAttributes(searchValue, sourcePage),
        enabled: searchValue !== undefined,
        retry: sourcePage ? false : 3
    });
};
